module.exports = __webpack_public_path__ + "static/media/logo.e4fb1568.png";